export default "__VITE_ASSET__DVxvhEgU__"